import React, { useState, useCallback } from 'react';

function ModalSlideButton({ onClose }) {
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const handleTouchStart = useCallback((e) => {
    setTouchStart(e.touches[0].clientY);
  }, []);

  const handleTouchMove = useCallback((e) => {
    setTouchEnd(e.touches[0].clientY);
  }, []);

  const handleTouchEnd = useCallback(() => {
    if (!touchStart || !touchEnd) return;

    const distance = touchEnd - touchStart;
    const isDownSwipe = distance > 30; // Increased threshold for better UX

    if (isDownSwipe) {
      onClose();
    }

    // Reset values
    setTouchStart(null);
    setTouchEnd(null);
  }, [touchStart, touchEnd, onClose]);

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="Slide down to close"
      className="modal-slide w-[65px] lg:hidden mx-auto border-b-4 border-himalayan-poppy rounded-[100px] mb-16 cursor-pointer"
      onClick={() => onClose()}
      // onTouchStart={handleTouchStart}
      // onTouchMove={handleTouchMove}
      // onTouchEnd={handleTouchEnd}
      // onKeyDown={(e) => e.key === 'Escape' && onClose()} // Added keyboard support
    />
  );
}

export default ModalSlideButton;
